<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="shopsSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="shopsItems"
    :loading="shopsLoading"
    :search-input.sync="shopsSearch"
    item-text="Description"
    item-value="id"
    :label="label ? label : $t('Shop.title')"
    return-object
  ></v-autocomplete>
  <!-- menu-props="closeOnContentClick" -->
</template>

<script>
import Shops from "@/api/shops";
import { mapState } from "vuex";

export default {
  name: "SearcherShops",

  props: {
    value: Array,
    districtCodes: Array,
    allianceBusinessIds: Array,
    label: String,
    psi_enable: Boolean,
    districtID: Number,
  },

  computed: {
    shopsItems() {
      return this.shops.map((shop) => {
        const Description = shop.shop_code + " / " + shop.shop_name;
        return Object.assign({}, shop, { Description });
      });
    },
    ...mapState(["settings"]),
  },

  data: () => ({
    shops: [],
    shopsLoading: false,
    shopsSearch: "",
    shopsSelected: [],
  }),

  mounted() {
    this.getShopsFromAPI();
  },

  methods: {
    getShopsFromAPI() {
      this.shopsLoading = true;
      var options = {
        alliance_business_ids: this.allianceBusinessIds,
      };
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 2
      ) {
        Object.assign(options, { district_codes: this.districtCodes });
      }
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        Object.assign(options, { district_id: this.districtID });
      }
      if (this.psi_enable) {
        Object.assign(options, { psi_enable: 1 });
      }
      Shops.fetchAllForSelect(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shops = response.data.shops;
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.shopsSelected = this.value;
      },
    },
    shopsSelected: {
      handler() {
        this.$emit("input", this.shopsSelected);
      },
    },
    districtCodes: {
      handler() {
        this.getShopsFromAPI();
      },
    },
    districtID: {
      handler() {
        this.getShopsFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getShopsFromAPI();
      },
    },
  },
};
</script>
